import React, { useCallback, useEffect, useState } from "react";
import VerticalProgressBar from "./vertical-progress-bar";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Coins } from "./coins";
import { useCoins } from "../queries/completion-queries";
import { useStage } from "../queries/stage-queries";
import { InfoBtn } from "./info-btn";
import { Intro } from "./intro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglass } from "@fortawesome/free-solid-svg-icons";

export const AscentinelPath = () => {
    const [showInfo, setShowInfo] = useState(false)
    const { coins } = useCoins()
    const { missingToNextStage, nextStage, stages, currentStage } = useStage()


    const scrollToCurrent = useCallback(() => {
        if (currentStage) {
            const element = document.getElementById(currentStage?.label);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [currentStage])

    useEffect(() => {
        const timer = setTimeout(scrollToCurrent, 700)
        return () => clearTimeout(timer)
    }, [scrollToCurrent])

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">Ascentinel Path <InfoBtn onClick={() => setShowInfo(true)} /></h2>
                    <Nav className="justify-content-end flex-grow-1 pe-3 d-flex flex-row gap-4">
                        <Nav.Link href="/history">
                            <FontAwesomeIcon icon={faHourglass} size="2x" />
                        </Nav.Link>
                        <Nav.Link href="/stats">
                            <img
                                src="/img/bar-chart.png"
                                width="25"
                                height="25"
                                className="d-inline-block align-top"
                                alt="React Bootstrap logo"
                            />

                        </Nav.Link>
                        <Nav.Link href="/missions">
                            <img
                                src="/img/sword.png"
                                width="25"
                                height="25"
                                className="d-inline-block align-top"
                                alt="React Bootstrap logo"
                            />
                        </Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            <VerticalProgressBar stages={stages} currentValue={coins} />
            <Intro show={showInfo} onClose={() => setShowInfo(false)} startScreen={0} />
            <Navbar sticky="bottom" key={'nav-bar-2'} expand={false} className="bg-body-secondary" hidden={!nextStage}>
                <Container fluid>
                    <Nav className="justify-content-center flex-grow-1 pe-3 d-flex flex-row gap-2">
                        <span className="mb-0 mt-2">Earn <Coins coins={missingToNextStage} fontSize={6} size={13} /> to be promoted to</span>
                        <img
                            src={nextStage?.icon}
                            width="35"
                            height="35"
                            className="d-inline-block align-top pt-2"
                            alt="NextRank"
                        />
                    </Nav>
                </Container>
            </Navbar>
        </>
    )
}